import React from "react";

import Layout from "./Layout";
const BetterExperienceModal = () => {
  return (
    <>
      <Layout
        heading="Better Experience"
        content=" Try to use the-tooltip on your computer or laptop, you will get
        better user experience."
      />
    </>
  );
};

export default BetterExperienceModal;
